<template>
    <Card class="mb-4" :header="$t(title)">
        <DataTable
            :items="items"
            :fields="fields"
            :loading="loading"
            :error="error"
            :total-rows="items.length"
            :per-page="10"
            sort-by="generatedAt"
            sort-direction="DESC"
            no-padding
        >
            <template #cell(actions)="data">
                <ButtonIcon
                    size="sm"
                    :disabled="!data.item.downloadable || isReportDownloading(data.item)"
                    :loading="isReportDownloading(data.item)"
                    @click="$emit('download', data.item)"
                >
                    {{ $t('dataExport.download') }}
                </ButtonIcon>
            </template>
        </DataTable>
    </Card>
</template>

<script>
    import ButtonIcon from '@/components/common/ButtonIcon.vue';
    import Card from '@/components/common/Card.vue';
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        components: {
            Card,
            DataTable,
            ButtonIcon,
        },
        props: {
            title: String,
            items: Array,
            loading: Boolean,
            downloadingIds: Array,
            error: {
                type: Object,
                default: null,
            },
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: 'ID' },
                    { key: 'name', label: this.$t('name') },
                    { key: 'startDate', label: this.$t('startDate') },
                    { key: 'endDate', label: this.$t('endDate') },
                    { key: 'actions', label: '', sortable: false },
                ];
            },
        },
        methods: {
            isReportDownloading(report) {
                return this.downloadingIds.includes(report.id);
            },
        },
    };
</script>
